import type { FaireProductEntity } from "../../entity_types/product";

export const p_7f8wjh233s: FaireProductEntity = {
  token: "p_7f8wjh233s",
  type: "product",
  name: "Plaid Large-capacity PVC Tote Bag for Women Shoulder Bag",
  brandToken: "b_785s5jxz4n",
  brandName: "NARWEY INC",
  imageUrl:
    "https://cdn.faire.com/fastly/73ef52ee985af3aff3c883564764500dcf044c9ae7f0466b0e037f3f5701b6c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d2ff8413141256c227951711f039f73497ced07a5a34d6b1853a16cecd7b897.jpeg",
    "https://cdn.faire.com/fastly/48b4e46152c908a4b760568bad7d698f1ede7d081be6e1fca7b30ac5fcb1a195.jpeg",
    "https://cdn.faire.com/fastly/fcd2b0932985c9f43c2a98a008ea915f6ba8cf6917ce25803e4939748cb55776.jpeg",
    "https://cdn.faire.com/fastly/61fe8d9a07d0d4de8b3ed1315273cc3be326f7b77503e4c987e056c76292ac10.jpeg",
    "https://cdn.faire.com/fastly/7dc41ccd2156bfa9fa3ceea87f83e2f0ee1c00e69757088bf015de8b74302f10.jpeg",
    "https://cdn.faire.com/fastly/cc172e8edb6a593a893f447efd525b54ca5cfcae3b998217550d160e8d0da4dd.jpeg",
    "https://cdn.faire.com/fastly/da20dda0c15d36c2cfff27dd5d55f45245eeac3b79eca2faedd7def81509f7d0.jpeg",
    "https://cdn.faire.com/fastly/8efb1c930d94d7b28f6052d799427ac4ab1540421e72d23d1a2ba543ad337f7f.jpeg",
  ],
  priceDollars: 21.19,
  description:
    "The pvc tote bag features a kraft paper and polyester inner with a unique texture, that enhances its quality.  The exterior is crafted from PVC material, offering a glossy and waterproof performance\nSpacious Size: With dimensions of 46 cm (18 inches) in length, 32cm (12.6 inches) in height, and 12cm (4.7 inches) in width, offering ample space for daily essentials.\nChristmas gifts—from mini skincare sets and chocolate boxes to scarves and personalized trinkets—this chic tote doubles as a festive gift bag that’s as practical as it is stylish\nThe plastic tote bag features a convenient hook-and-loop closure (Velcro) for quick access\nThe letters print tote bag for women not only meets the needs of shopping, work, university, daily outings and city travel, but is also a thoughtful choice for friends and family on birthdays and festivals\nWarm Tips: To reduce our carbon footprint, the bags ship in compact folded packaging.   When you receive the item, it may have some wrinkles, but after a few days it will return to its original shape.",
  tags: [],
  msrpDollars: 42.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:48.554Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
